import { useMemo } from 'react'

import { useStoreState } from '../store'

export const usePreKyc = () => {
  const accountToken = useStoreState(state => state.onboarding.accountToken)
  const kycReferenceId = useStoreState(state => state.onboarding.kycReferenceId)
  const ssnLastFour = useStoreState(state => state.onboarding.ssnLastFour)
  const isPreKyc = useMemo(
    () => accountToken && kycReferenceId,
    [accountToken, kycReferenceId]
  )

  const isLimitedAccount = useMemo(
    () => accountToken && !kycReferenceId,
    [accountToken, kycReferenceId]
  )

  return {
    accountToken,
    kycReferenceId,
    ssnLastFour,
    isPreKyc,
    isLimitedAccount,
  }
}
